<ng-template #projectEdit let-modal>
  <div class="modal-header">
    <h4 class="m-0" i18n="@@Page.MasterData.Projects.Edit">[i18n] Edit project</h4>
    <button type="button" class="btn modal-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <svg class="bi action-icon" fill="currentColor">
        <use xlink:href="assets/icons.svg#x-circle"/>
      </svg>
    </button>
  </div>
  <div class="modal-body">
    <form id="projectForm" [formGroup]="projectForm" (ngSubmit)="save()" #form="ngForm">
      <div class="row g-4">
        <div class="col-lg-6">
          <label for="title" class="form-label" i18n="@@DTO.ProjectDto.Title">[i18n] Title</label>
          <input id="title"
                 type="text"
                 class="form-control"
                 [readonly]="isReadOnly"
                 placeholder="[i18n] Project name"
                 i18n-placeholder="@@DTO.ProjectDto.TitlePlaceholder"
                 formControlName="title"
                 ngbAutofocus>
        </div>
        <div class="col-lg-6">
          <!--suppress XmlInvalidId -->
          <label for="customerName" class="form-label" i18n="@@DTO.ProjectDto.CustomerId">[i18n] Customer</label>
          <ng-select [items]="customers$ | async"
                     [selectOnTab]="true"
                     [readonly]="isReadOnly"
                     bindValue="id"
                     bindLabel="value"
                     labelForId="customerName"
                     placeholder="[i18n] Select customer"
                     i18n-placeholder="@@DTO.ProjectDto.CustomerIdPlaceholder"
                     formControlName="customerId">
            <ng-template ng-option-tmp let-item="item">
              <span [ngClass]="{'text-secondary': item.hidden}">{{item.value}}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-lg-12">
          <label for="comment" class="form-label" [tsOptionalLabel] i18n="@@DTO.ProjectDto.Comment">[i18n] Comment</label>
          <textarea id="comment" class="form-control" [readonly]="isReadOnly" formControlName="comment" rows="3"></textarea>
        </div>
        <div class="col-lg-12">
          <div class="form-check form-switch" [ngClass]="{disabled: isReadOnly}">
            <input class="form-check-input" type="checkbox" id="hidden" formControlName="hidden">
            <label class="form-label" for="hidden" i18n="@@DTO.ProjectDto.Hidden">
              [i18n] Hidden
            </label>
          </div>
        </div>
      </div>
      <hr class="text-secondary" *ngIf="form.submitted && form.invalid">
      <ts-form-validation-errors></ts-form-validation-errors>
    </form>
  </div>
  <div class="modal-footer">
    <button id="cancel" form="projectForm" type="button" class="btn btn-secondary me-3" (click)="modal.close()">
      <ng-container i18n="@@Common.Cancel">[i18n] Cancel</ng-container>
    </button>
    <button id="save" form="projectForm" type="submit" class="btn btn-primary" [disabled]="isReadOnly">
      <svg class="bi check-lg" fill="currentColor">
        <use xlink:href="assets/icons.svg#check-lg"/>
      </svg>
      <ng-container i18n="@@Common.Save">[i18n] Save</ng-container>
    </button>
  </div>
</ng-template>
